export default {
  "sub-container": "_sub-container_1uj689",
  "closure-guide": "_closure-guide_1uj689",
  "wording": "_wording_1uj689",
  "download-link": "_download-link_1uj689",
  "back-to-qonto": "_back-to-qonto_1uj689",
  "another-migration": "_another-migration_1uj689"
};
